var render = function render(){var _vm=this,_c=_vm._self._c;return _c('main',{staticClass:"top-padding",attrs:{"id":"contents"}},[(_vm.hasTitle)?_c('div',{staticClass:"page-top"},[_vm._m(0)]):_vm._e(),(_vm.isNoticeView)?_c('NoticeView'):_vm._e(),(_vm.isEventView)?_c('EventView'):_vm._e()],1)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page-top-inner-wrap"},[_c('h1',{staticClass:"page-title",attrs:{"tabindex":"0"}},[_vm._v("고객센터")])])
}]

export { render, staticRenderFns }